import React from 'react'

import { NavBar } from '../NavBar'

export type PageProps = {
  children: React.ReactNode
  title?: string
}

export const Page: React.FC<PageProps> = ({ children, title }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <NavBar title={title} />
      <main className="-mt-32">
        <div className="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow px-5 py-6 sm:px-6">
            <div className="min-h-96 rounded-lg">{children}</div>
          </div>
        </div>
      </main>
    </div>
  )
}
